import { ReactElement, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FAL_CLOCK } from 'const/icons'
import { isBrandRefreshEnabled } from 'helpers/getBrandRefreshPhase'
import i18n from 'strings/i18n'
import InactivityTimer from 'syf-component-library/ui/templates/InactivityTimer'
import useLogoutRedirect from 'hooks/useLogoutRedirect'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import InactivityV3Overrides from './subcomponents'

const InactivityModal = (): ReactElement => {
  const { _SFDDL: SFDDL } = window
  const { isLoggedIn, handleLogoutAndRedirect } = useLogoutRedirect()

  const headerRef = useRef()
  const brandRefreshEnabled = isBrandRefreshEnabled()

  const logoutHandler = () => {
    handleLogoutAndRedirect(SFDDL?.pageInfo?.PageFunction, 'SessionTimeout')
    triggerAnalyticsEvent({
      ClientName: '',
      Country_Language: '',
      CustomerType: '',
      ErrorMessage: '',
      Message: '',
      PNL: '',
      PageFunction: '',
      PageKind: '',
      PageSubFunction: '',
      Product: '',
      RelyingParty: '',
      SiteIdentifier: '',
      Token: '',
      numberOfAccounts: '',
      pageName: '',
      previouslyVisited: '',
      MessageType: 'session timeout'
    })
  }

  const modalTexts = {
    modalTitle: `${i18n({ inactivityModal: 'modalTitle' })}`,
    promptTitle: `${i18n({ inactivityModal: 'promptTitle' })}`,
    countdownWarning: `${i18n({ inactivityModal: 'countdownWarning' })}`,
    continueButton: `${i18n({ inactivityModal: 'continueButton' })}`,
    signOffButton: `${i18n({ inactivityModal: 'logOffButton' })}`,
    seconds: `${i18n({ inactivityModal: 'seconds' })}`
  }

  return (
    <>
      {brandRefreshEnabled && <InactivityV3Overrides />}
      <InactivityTimer
        headerRef={headerRef}
        isLoggedIn={isLoggedIn}
        text={modalTexts}
        logoutHandler={logoutHandler}
        icon={<FontAwesomeIcon icon={FAL_CLOCK} size="4x" />}
      />
    </>
  )
}

export default InactivityModal
